export type StringTransformRule = {
  validate: (arg: string) => boolean;
  transform: (arg: string) => string;
};

/**
 * Transforms a string with the first applicable rule from an array of StringTransformRule objects.
 *
 * @param {string} text - The string to process.
 * @param {Array} rules - An array of StringTransformRule objects.
 * @return {string} The transformed string.
 */
export const applyStringTransformRules = (
  text: string,
  rules: Array<StringTransformRule>
) => {
  const result = rules.find((rule) => rule.validate(text));

  return result ? result.transform(text) : text;
};

export const trimString = (
  text: string,
  maxLength: number,
  end = "..."
): string => {
  if (!text) return "";

  return text.length > maxLength
    ? `${text.substring(0, maxLength).trim()}${end}`
    : text;
};
